import Vue from 'vue'
import animate from 'v-animate-css'

Vue.use(animate)